import { useDispatch } from 'react-redux';
import { getPerformancePropertyConsultationsCard } from '@/store/slices/components/dashboard/service';
import ConsultedEntities from '../ConsultedEntities';
import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import ChatIcon from '@/public/images/dashboard/chat.svg';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import { useTrackPerformanceTabCard } from '../../customHooks/useTrackDashboard';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';

function MostConsultedProperties() {
  const dispatch = useDispatch();
  const track = useTrackPerformanceTabCard();

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'propertyConsultations',
        subkey: 'sortBy',
        value: 'inquiry',
      })
    );
    dispatch(
      setPerformanceModals({
        key: 'propertyConsultations',
        subkey: 'sortDirection',
        value: 'desc',
      })
    );
    dispatch(
      setPerformanceModals({
        key: 'propertyConsultations',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <ConsultedEntities
      id="most-consulted-properties"
      title={Trans(translations, 'MostInquiredProperties')}
      stateKey="propertyConsultations"
      stateSubkey="most_consulted"
      entityType="property"
      fetchCallback={(query) =>
        dispatch(getPerformancePropertyConsultationsCard({ query }))
      }
      openTableCallback={handleOpenTable}
      trackCallback={(element) => track.mostInquiriedProperties(element)}
      emptyStateChildren={
        <DashboardEmptyStateCard
          icon={ChatIcon}
          title={Trans(
            translations,
            'HereYouWillSeeYourMostInquiredProperties'
          )}
          description={Trans(
            translations,
            'PromotingYourPropertiesIsKeyToFindLeads'
          )}
        />
      }
    />
  );
}

export default MostConsultedProperties;
